<template>
  <div class="locale-changer" style="z-index:10">
    <select v-model="$i18n.locale" style="border:0">
      <option :value="locale.code" v-for="locale in locales" :key="locale.code">
        {{locale.name}}
      </option>
    </select>
  </div>
</template>

<script>
import { getSupportedLocales } from "@/util/i18n/supported-locales"
export default {
  name:"locale-changer",
  data: () => ({ locales: getSupportedLocales() })
}
</script>

<style>
    .locale-changer{
        overflow-x: hidden;
        right:10px;
        position:absolute;
    }

</style>

